import React, { useContext } from 'react'
import { orderContext } from '../Contexts/OrderProvider'
import { detailContext } from '../Contexts/DetailProvider'
import './finalpage.css'
import { BrowserRouter as Router ,Switch,Route,useHistory } from 'react-router-dom';

function Finalpage(){
    
const [state,setState] = useContext(detailContext);

    return (
        <div>
              <div className="box">
            <h2>Thank You for choosing us! We are looking forward to seeing you in our venue!</h2><br/>
            <h4>
                Your order number is {state.order_number}.
            </h4>
        </div>
        </div>
      
    )
}
export default Finalpage;